export const getGoogleMapsApiKey = (): string => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  // Fallback to the API key from mobile app for development
  const fallbackApiKey = "AIzaSyAqcAUHG9s2M8VHs3h5iACCmS_CPfJDrgo";

  if (!apiKey) {
    console.warn(
      "REACT_APP_GOOGLE_MAPS_API_KEY not found, using fallback API key"
    );
    return fallbackApiKey;
  }

  console.log(
    "Using Google Maps API key from environment:",
    apiKey.substring(0, 10) + "..."
  );
  return apiKey;
};
